import config from "../config";

export const GOOGLE_AUTH_URL = `https://accounts.google.com/o/oauth2/v2/auth?client_id=${config.CLIENT_ID_GOOGLE}&response_type=code&redirect_uri=${config.REDIRECT_URI_GOOGLE}&scope=${config.SCOPE_GOOGLE}`;